import clsx from 'clsx'
import React, { useRef } from 'react'
import {useDrag, useDrop} from 'react-dnd'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {faSort, faTrashAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Editor from '../../components/editable-html'

export default function Choice (props) {
  const {index, questionCount, context, question, choice, onChoiceMove, onChoiceTextChange, onChoiceCorrectChange, onChoiceDropped, onDeleteChoice} = props
  const {id} = question
  const {translate} = context
  const type = context.quizQuestionTypes.find(t => t.id == question.type)
  const canDelete = questionCount > type.properties.minChoices

  const ref = useRef(null)
	const config = {readonly: false}

  const [{ isDragging, dragIndex }, drag, preview] = useDrag({
    item: { type: 'CHOICE', index},
    collect: (monitor, item) => {
      const {index} = monitor.getItem() || {}
      return {
        isDragging: monitor.isDragging(),
        dragIndex: index
      }
    },
  })

  const [, drop] = useDrop({
    accept: 'CHOICE',
    hover(item, monitor) {

      if (item.index == index) return

      const {current} = ref
      if (!current) return

      const {top, bottom} = current.getBoundingClientRect()
      const middle = (bottom - top) / 2
      const {y} = monitor.getClientOffset()
      const dY = y - top
      const goingUp = item.index > index
      if (goingUp && dY < middle) return
      if (!goingUp && dY > middle) return

      onChoiceMove && onChoiceMove(item.index, index)
      item.index = index

    },
    drop(item, monitor) {
      !monitor.didDrop() && onChoiceDropped && onChoiceDropped()
    }
  })


  const opacity = isDragging ? 0 : 1
  preview(drop(ref))

  const answerIndex = String.fromCharCode(Math.min(isDragging ? dragIndex : index, 20) + 97)

  return (
    <Box id={choice.id} ref={ref} style={{opacity}} className={"choice"}>
      <Box className="header">
        <Box className="sorter" ref={drag}><FontAwesomeIcon icon={faSort} /></Box>
        <Box className="filler" />
        {canDelete && (
          <Box className="delete" onClick={e => {
            e.stopPropagation()
            onDeleteChoice && onDeleteChoice(choice.id)
          }}><FontAwesomeIcon icon={faTrashAlt} /></Box>
        )}
      </Box>
      <Box className="index">{answerIndex})</Box>
      <Box className="editor">
        <Editor
          context={context}
          html={choice.html || ''}
          onChange={text => onChoiceTextChange && onChoiceTextChange(choice.id, text)}
        />
      </Box>
      <Box className="correct">
        <FormControlLabel
          control={<Checkbox checked={choice.correct} onChange={e => onChoiceCorrectChange && onChoiceCorrectChange(choice.id, e.target.checked)} />}
          label={translate('correct-answer')} />
      </Box>
    </Box>
  )
}
